var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudRight2 = function SvgCloudRight2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 35,
    fill: "none",
    viewBox: "0 0 84 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCF2FF",
    d: "M124.64 25.134c0-.701-.58-1.27-1.297-1.27h-18.239c-.671-10.994-10.002-19.71-21.407-19.71-8.508 0-15.855 4.841-19.325 11.866a14.53 14.53 0 0 0-10.998-4.988c-1.614 0-3.16.273-4.616.753C44.209 4.708 36.168 0 26.988 0 13.23 0 1.999 10.575 1.329 23.865h-.03C.58 23.865 0 24.433 0 25.134c0 .7.58 1.27 1.297 1.27h122.046c.717 0 1.297-.57 1.297-1.27"
  })));
};
export default SvgCloudRight2;